import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Create Invoice',
      description: 'Generate new customer invoice',
      icon: 'FileText',
      color: 'primary',
      action: () => navigate('/invoices')
    },
    {
      title: 'Record Expense',
      description: 'Add business expense',
      icon: 'Receipt',
      color: 'secondary',
      action: () => navigate('/expenses')
    },
    {
      title: 'Add Transaction',
      description: 'Manual journal entry',
      icon: 'Plus',
      color: 'accent',
      action: () => navigate('/chart-of-accounts')
    },
    {
      title: 'Bank Reconciliation',
      description: 'Match bank statements',
      icon: 'Landmark',
      color: 'success',
      action: () => navigate('/bank-reconciliation')
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl text-foreground">
          Quick Actions
        </h2>
        <Icon name="Zap" size={20} color="var(--color-accent)" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
        {actions?.map((action, index) => (
          <button
            key={index}
            onClick={action?.action}
            className="flex items-start gap-3 p-3 md:p-4 rounded-lg border border-border hover:border-primary/30 hover:bg-muted/50 transition-smooth hover-lift active-press text-left"
          >
            <div className={`
              w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center flex-shrink-0
              ${action?.color === 'primary' ? 'bg-primary/10' : ''}
              ${action?.color === 'secondary' ? 'bg-secondary/10' : ''}
              ${action?.color === 'accent' ? 'bg-accent/10' : ''}
              ${action?.color === 'success' ? 'bg-success/10' : ''}
            `}>
              <Icon name={action?.icon} size={20} color={`var(--color-${action?.color})`} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-body font-medium text-sm md:text-base text-foreground mb-1">
                {action?.title}
              </h3>
              <p className="caption text-muted-foreground line-clamp-1">
                {action?.description}
              </p>
            </div>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0 mt-1" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;